import { Permission } from '@/lib/permissions/v1'

export enum KamailioAddressRouteName {
    Index = 'kamailio.server.addresses.index',
    Create = 'kamailio.server.addresses.create',
    Edit = 'kamailio.server.addresses.edit',
}

export enum KamailioUsageRouteName {
    Index = 'kamailio.server.usage.index',
}

export enum KamailioGatewayRouteName {
    Index = 'kamailio.server.gateways.index',
    Create = 'kamailio.server.gateways.create',
    Edit = 'kamailio.server.gateways.edit',
}

export enum KamailioRuleRouteName {
    Index = 'kamailio.server.rules.index',
    Create = 'kamailio.server.rules.create',
    Edit = 'kamailio.server.rules.edit',
}

export enum KamailioServiceRouteName {
    Index = 'kamailio.server.services.index',
    Create = 'kamailio.server.services.create',
    Edit = 'kamailio.server.services.edit',
}

export enum KamailioTrustedRouteName {
    Index = 'kamailio.server.trusted.index',
    Create = 'kamailio.server.trusted.create',
    Edit = 'kamailio.server.trusted.edit',
}

export default {
    path: '/kamailio',
    name: 'kamailio.index',
    component: () => import('./views/Index.vue'),
    meta: {
        label: 'Kamailio',
        icon: 'fal fa-envelope-open-text fa-fw',
        permission: 'manage-kamailio',
        auth: true,
        module: 'metatech/kamailio',
    },
    children: [
        {
            path: 'servers/:serverUuid',
            name: 'kamailio.server.show',
            component: () => import('./views/server/Show.vue'),
            meta: {
                label: 'Server',
                permission: 'manage-kamailio',
            },
            children: [
                {
                    path: 'addresses',
                    name: KamailioAddressRouteName.Index,
                    component: () => import('./views/server/address/Index.vue'),
                    meta: {
                        label: 'Addresses',
                        icon: 'fal fa-map-marker-alt fa-fw',
                        permission: 'kamailio:address:view-any',
                    },
                    children: [
                        {
                            path: 'create',
                            name: KamailioAddressRouteName.Create,
                            component: () => import('./views/server/address/Index.vue'),
                            meta: {
                                label: 'Create Address',
                                permission: 'kamailio:address:create',
                            },
                        },
                        {
                            path: ':addressUuid/edit',
                            name: KamailioAddressRouteName.Edit,
                            component: () => import('./views/server/address/Index.vue'),
                            meta: {
                                label: 'Edit Address',
                                permission: 'kamailio:address:update',
                            },
                        },
                    ],
                },
                {
                    path: 'usage',
                    name: KamailioUsageRouteName.Index,
                    component: () => import('./views/server/usage/Index.vue'),
                    meta: {
                        label: 'Usage',
                        icon: 'fal fa-cabinet-filing fa-fw',
                        permission: Permission.KamailioUsageViewAny,
                    },
                },
                {
                    path: 'gateways',
                    name: KamailioGatewayRouteName.Index,
                    component: () => import('./views/server/gateway/Index.vue'),
                    meta: {
                        label: 'Gateways',
                        icon: 'fal fa-torii-gate fa-fw',
                        permission: Permission.KamailioGatewayViewAny,
                    },
                    children: [
                        {
                            path: 'create',
                            name: KamailioGatewayRouteName.Create,
                            component: () => import('./views/server/gateway/Index.vue'),
                            meta: {
                                label: 'Create Gateway',
                                permission: Permission.KamailioGatewayCreate,
                            },
                        },
                        {
                            path: ':gatewayUuid/edit',
                            name: KamailioGatewayRouteName.Edit,
                            component: () => import('./views/server/gateway/Index.vue'),
                            meta: {
                                label: 'Edit Gateway',
                                permission: Permission.KamailioGatewayUpdate,
                            },
                        },
                    ],
                },
                {
                    path: 'rules',
                    name: KamailioRuleRouteName.Index,
                    component: () => import('./views/server/rule/Index.vue'),
                    meta: {
                        label: 'Rules',
                        icon: 'fal fa-clipboard-list-check fa-fw',
                        permission: Permission.KamailioRuleViewAny,
                    },
                    children: [
                        {
                            path: 'create',
                            name: KamailioRuleRouteName.Create,
                            component: () => import('./views/server/rule/Index.vue'),
                            meta: {
                                label: 'Create Rule',
                                permission: Permission.KamailioRuleCreate,
                            },
                        },
                        {
                            path: ':ruleUuid/edit',
                            name: KamailioRuleRouteName.Edit,
                            component: () => import('./views/server/rule/Index.vue'),
                            meta: {
                                label: 'Edit Rule',
                                permission: Permission.KamailioRuleUpdate,
                            },
                        },
                    ],
                },
                {
                    path: 'services',
                    name: KamailioServiceRouteName.Index,
                    component: () => import('./views/server/service/Index.vue'),
                    meta: {
                        label: 'Services',
                        icon: 'fal fa-cogs fa-fw',
                        permission: Permission.KamailioServiceViewAny,
                    },
                    children: [
                        {
                            path: 'create',
                            name: KamailioServiceRouteName.Create,
                            component: () => import('./views/server/service/Index.vue'),
                            meta: {
                                label: 'Create Service',
                                permission: Permission.KamailioServiceCreate,
                            },
                        },
                        {
                            path: ':serviceUuid/edit',
                            name: KamailioServiceRouteName.Edit,
                            component: () => import('./views/server/service/Index.vue'),
                            meta: {
                                label: 'Edit Service',
                                permission: Permission.KamailioServiceUpdate,
                            },
                        },
                    ],
                },
                {
                    path: 'trusted',
                    name: KamailioTrustedRouteName.Index,
                    component: () => import('./views/server/trusted/Index.vue'),
                    meta: {
                        label: 'Trusted',
                        icon: 'fal fa-badge-check fa-fw',
                        permission: Permission.KamailioTrustedViewAny,
                    },
                    children: [
                        {
                            path: 'create',
                            name: KamailioTrustedRouteName.Create,
                            component: () => import('./views/server/trusted/Index.vue'),
                            meta: {
                                label: 'Create Trusted IP',
                                permission: Permission.KamailioTrustedCreate,
                            },
                        },
                        {
                            path: ':trustedUuid/edit',
                            name: KamailioTrustedRouteName.Edit,
                            component: () => import('./views/server/trusted/Index.vue'),
                            meta: {
                                label: 'Edit Trusted IP',
                                permission: Permission.KamailioTrustedUpdate,
                            },
                        },
                    ],
                },
            ],
        },
    ],
}
